import React from 'react';
import * as R from 'ramda';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpIcon from '@mui/icons-material/EmojiObjects';
import { visuallyHidden } from '@mui/utils';
import { useStyles } from './styles';
import { withBlank } from '../utils';
import Tooltip from '../Tooltip';

var CustomExpansionPanel = function CustomExpansionPanel(_ref) {
  var _cx, _cx2, _cx3, _cx4, _cx5;

  var id = _ref.id,
      topElementComponent = _ref.topElementComponent,
      onChangeActivePanel = _ref.onChangeActivePanel,
      label = _ref.label,
      tag = _ref.tag,
      _ref$overflow = _ref.overflow,
      overflow = _ref$overflow === undefined ? true : _ref$overflow,
      children = _ref.children,
      isOpen = _ref.isOpen,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === undefined ? true : _ref$maxHeight,
      fullWidth = _ref.fullWidth,
      _ref$testId = _ref.testId,
      testId = _ref$testId === undefined ? 'expansion_panel' : _ref$testId,
      isPinned = _ref.isPinned,
      pinnedLabel = _ref.pinnedLabel,
      moreFilters = _ref.moreFilters,
      _ref$isNarrow = _ref.isNarrow,
      isNarrow = _ref$isNarrow === undefined ? false : _ref$isNarrow,
      _ref$isPopper = _ref.isPopper,
      isPopper = _ref$isPopper === undefined ? false : _ref$isPopper,
      _ref$popperLabels = _ref.popperLabels,
      popperLabels = _ref$popperLabels === undefined ? {} : _ref$popperLabels;

  var classes = useStyles();

  return React.createElement(
    Accordion,
    {
      'data-testid': testId,
      className: cx((_cx = {}, _cx[classes.fullWidth] = fullWidth, _cx)),
      expanded: isOpen,
      onChange: R.is(Function)(onChangeActivePanel) ? function () {
        return onChangeActivePanel(id);
      } : undefined,
      classes: { root: isNarrow ? classes.panelBorder : classes.panel },
      elevation: 0,
      'aria-expanded': isOpen
    },
    React.createElement(
      AccordionSummary,
      {
        'data-testid': testId + '_panel',
        className: cx(classes.container, (_cx2 = {}, _cx2[classes.moreFiltersContainer] = moreFilters, _cx2)),
        classes: {
          content: cx(classes.content, classes.ellipsis, (_cx3 = {}, _cx3[classes.moreFiltersContent] = moreFilters, _cx3)),
          expandIconWrapper: cx(classes.iconSummaryPanel, (_cx4 = {}, _cx4[classes.moreFiltersExpandIcon] = moreFilters, _cx4))
        },
        expandIcon: React.createElement(ExpandMoreIcon, null),
        'aria-controls': id,
        id: id,
        'aria-label': isPinned ? label + ' ' + pinnedLabel + ' ' : label
      },
      React.createElement(
        Grid,
        { container: true, item: true, className: classes.ellipsis },
        isPinned && React.createElement(
          Typography,
          { style: visuallyHidden },
          pinnedLabel
        ),
        React.createElement(
          Typography,
          {
            noWrap: true,
            variant: 'body2',
            title: label,
            className: moreFilters ? classes.title : classes.label
          },
          label
        ),
        isPinned && React.createElement(
          'div',
          { className: classes.pinnedIcon },
          '\u2022'
        ),
        isPopper && !R.isEmpty(R.propOr('', 'title', popperLabels)) && React.createElement(
          Tooltip,
          {
            variant: 'light',
            tabIndex: 0,
            'aria-label': R.propOr('', 'ariaLabel', popperLabels),
            'aria-hidden': false,
            placement: 'bottom-start',
            title: R.propOr('', 'title', popperLabels)
          },
          React.createElement(HelpIcon, { fontSize: 'small' })
        )
      ),
      R.isNil(tag) ? null : tag
    ),
    R.isNil(topElementComponent) ? null : topElementComponent,
    React.createElement(
      AccordionDetails,
      {
        id: id,
        'aria-label': label,
        className: cx(classes.details, (_cx5 = {}, _cx5[classes.overflow] = overflow, _cx5[classes.height] = maxHeight, _cx5))
      },
      children
    )
  );
};

CustomExpansionPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  testId: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  topElementComponent: PropTypes.element,
  onChangeActivePanel: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  pinnedLabel: PropTypes.string,
  tag: PropTypes.element,
  overflow: PropTypes.bool,
  isOpen: PropTypes.bool,
  isBlank: PropTypes.bool,
  maxHeight: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  fullWidth: PropTypes.bool,
  isPinned: PropTypes.bool,
  moreFilters: PropTypes.bool,
  isNarrow: PropTypes.bool,
  isPopper: PropTypes.bool,
  popperLabels: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    ariaLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  })
} : {};

export default withBlank(function (_ref2) {
  var isBlank = _ref2.isBlank;
  return { isBlank: isBlank };
})(CustomExpansionPanel);